import axios from "axios";
import {baseUrl} from "../../utils/baseUrl";
import {SuccessToaster , ErrorToaster} from '../../components/Toaster'

export const contactUsApi = async (data , setName , setEmail , setPhone , setSubject , setMessage) => {

    try {
      const response = await axios.post(`${baseUrl}contact-us`, data);
     console.log("response from contactUsApi" , response)
      SuccessToaster(response.data.message);
      setName("");
      setEmail("");
      setPhone("");
      setSubject("");
      setMessage("");
      return response;


  
    } catch (error) {
      ErrorToaster(error.response.data.message);
    
      return null;
    } finally {

    }
    
  };